import thunkMiddleware from 'redux-thunk';
import { history } from './history';
import { routerMiddleware } from 'connected-react-router';

export default [
  thunkMiddleware,
  routerMiddleware(history)
];
